import { createFileRoute } from "@tanstack/react-router";
import { TripDetailPageClient } from "@/components/trips/trip-detail-page-client";

function AdminTripDetailPage() {
  return <TripDetailPageClient />;
}

export const Route = createFileRoute("/_app/admin/trips/$id")({
  component: AdminTripDetailPage,
});
